<!--
 * @Author: zhonghao
 * @Date: 2024-08-20 08:23:56
-->
<template>
  <div v-if="fromType !== 'case'">
    <!-- <img src="@/assets/images/common/icon-back2.png" v-if="curPath === '/topicDetail'" @click="handleReturn" class="icon-back" alt=""> -->
    <img src="@/assets/images/common/ic_back.png" v-if="curPath !== '/gradeHomePage'" @click="handleReturn" class="icon-back" alt="">
  </div>
</template>
<script>
import { setSha, traceClickURL } from '@/utils/util'
export default {
  data() {
    return {
    }
  },
  computed: {
    userInfo () {
      return this.$store.getters.userInfo
    },
    curPath () {
      return this.$route.path
    },
    fromType() {
      return this.$route.query.fromType
    }
  },
  methods: {
    handleReturn() {
      if (this.$route.query.entrancePage === 'search') {
        this.$router.go(-1)
        return
      }
      if (this.$route.path === '/gradeHomePage') {
        this.$router.go(-1)
        // this.$router.push({
        //   path: '/gradeHomePage',
        //   query: {
        //     classId: this.$route.query.classId
        //   }
        // })
      } else {
        if (this.$route.query.classId > 0) {
          this.$router.push({
            path: '/gradeHomePage',
            query: {
              classId: this.$route.query.classId
            }
          })
        } else {
          if (this.$route.query.type === 'dcc') {
            this.$router.go(-1)
          } else {
            setTimeout(() => { traceClickURL() })
            let openidBindli = `&unionid=${this.userInfo.unionId}&openid=${this.userInfo.iepOpenId}${setSha(`xxbiep${this.userInfo.iepOpenId}`)}`
            window.location.href = `${process.env.bingliUrl}/wap/index.html#/homePage?listType=4${openidBindli}`
          }
        }
      }
    }
  }
}
</script>
<style lang="less" scoped>
.icon-back {
  width: 41px;
  height: 41px;
  position: fixed;
  right: 18px;
  bottom: 147px;
  z-index: 99;
}
</style>



// WEBPACK FOOTER //
// src/views/grade/components/returnBack.vue